import { round2, formatImporte } from '@/utils/money';
import { Grid, InputAdornment, TextField, Typography, Button } from '@material-ui/core';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { LoadingButton } from '@mui/lab';

import Alert from '@mui/material/Alert';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Field, Form, Formik } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormStyles } from '../../../styles/formStyles';
import { LinesTable } from './LinesTable';
import { validationSchemaOrder } from '../../../utils/schemaValidationForm';
import { FormikDatePicker } from '../../ui/FormikDatePicker';
import { startUpdateInvoice } from '../../../redux/actions/sales';
import esLocale from 'date-fns/locale/es';
import { EuroOutlined, MonetizationOn } from '@material-ui/icons';
import { getTotalInvoice, getTotalInvoiceDolares } from '../../../utils/utils';
import { Box } from '@mui/material';
import { navigate } from '@reach/router';
import { ROLADMIN, ROLREVENDEDOR, ROLVENDEDOR } from '../../../utils/constants';
import { obtenerPrecioEuros } from '../../../utils/exchange';

export const Detail = ({ showActionButtons = true }) => {
  const classes = useFormStyles();
  const { activeEdit } = useSelector(state => state.invoice);
  const fromB2B = activeEdit?.OrigenB2B;
  const dispatch = useDispatch();
  const { idRol, moneda: monedaUsuario, esAgencia } = useSelector(state => state.auth);

  const initialValues = {
    FechaVenta: activeEdit?.FechaVenta,
    HotelCliente: activeEdit?.HotelCliente,
    PorcDescuento: activeEdit?.PorcDescuento,
    Observaciones: activeEdit?.Observaciones,
    FechaEnvioPresupuesto: activeEdit?.FechaEnvioPresupuesto,
    FechaPagoReserva: activeEdit?.FechaPagoReserva,
    FechaFactura: activeEdit?.FechaFactura,
    PresupuestoEnviado: activeEdit?.PresupuestoEnviado,
    ReservaPagada: activeEdit?.ReservaPagada,
    ImporteFactura: +activeEdit?.ImporteFactura,
    VersionFila: activeEdit?.VersionFila,
    PkVentas: activeEdit?.PkVentas,
  };

  const getTotal = () => {
    let total = 0;
    activeEdit?.LineasVentaCompuestas?.forEach(e => {
      total += +e.Descuento;
    });
    return round2(total);
  };

  const getTotalTasas = () => {
    let total = 0;
    activeEdit?.LineasVentaCompuestas?.forEach(e => {
      if (e?.TasaDolares) total += obtenerPrecioEuros(e?.TasaDolares, e?.CambioEuros, e?.CambioDolares) * e?.Unidades;
    });
    return round2(total);
  };
  const getTotalTasasDolares = () => {
    let total = 0;
    activeEdit?.LineasVentaCompuestas?.forEach(e => {
      if (e?.TasaDolares) total += e?.TasaDolares * e?.Unidades;
    });
    return round2(total);
  };

  const getTotalNeto = () => {
    let total = 0;
    activeEdit?.LineasVentaCompuestas?.forEach(e => {
      if (e?.ReservaLineaEuros) total += e?.ReservaLineaEuros * e?.Unidades;
    });
    return round2(total);
  };

  const getTotalNetoDolares = () => {
    let total = 0;
    activeEdit?.LineasVentaCompuestas?.forEach(e => {
      if (e?.ReservaLineaDolares) total += e?.ReservaLineaDolares * e?.Unidades;
    });
    return round2(total);
  };

  // PAGO CLIENTE A AGENCIA
  const getPagoClienteAgencia = () => {
    let total = 0;
    activeEdit?.LineasVentaCompuestas?.forEach(e => {
      total += e?.ReservaLineaEuros * e?.Unidades;
    });
    return round2(total);
  };
  // PAGO AGENCIA A XPLORA
  const getPagoAgenciaXploraEuros = () => {
    let total = 0;
    activeEdit?.LineasVentaCompuestas?.forEach(e => {
      if (activeEdit?.Usuario?.MargenConfiguradoEnServicios) {
        // 0
        total += 0;
      } else if (activeEdit?.Usuario?.Comisiona) {
        // Margen Xplora
        total += e?.ReservaEuros * e?.Unidades;
      } else {
        // Margen xplora
        total += e?.ReservaEuros * e?.Unidades;
      }
    });
    return round2(total);
  };

  const getPagoAgenciaXploraDolares = () => {
    let total = 0;
    activeEdit?.LineasVentaCompuestas?.forEach(e => {
      if (activeEdit?.Usuario?.MargenConfiguradoEnServicios) {
        // 0
        total += 0;
      } else if (activeEdit?.Usuario?.Comisiona) {
        // Margen Xplora
        total += ((e?.ReservaEuros * e?.CambioEuros) / e?.CambioDolares) * e?.Unidades;
      } else {
        // Margen xplora
        total += ((e?.ReservaEuros * e?.CambioEuros) / e?.CambioDolares) * e?.Unidades;
      }
    });
    // Conversión de divisa: a entero, como `obtenerPrecioDolares`
    return Math.round(total);
  };

  // PAGO PROVEEDOR A XPLORA
  const getPagoProveedorXplora = () => {
    let total = 0;
    activeEdit?.LineasVentaCompuestas?.forEach(e => {
      if (activeEdit?.Usuario?.MargenConfiguradoEnServicios) {
        // 0
        total += e?.ReservaEuros * e?.Unidades;
      } else if (activeEdit?.Usuario?.Comisiona) {
        // Margen Xplora
        total += 0;
      } else {
        // Margen xplora
        total += 0;
      }
    });
    return round2(total);
  };
  // INSITU + TRANSPORTE
  const getInSituConTransporte = () => {
    let total = 0;
    activeEdit?.LineasVentaCompuestas?.forEach(e => {
      total += e?.InSituConTransporteDolares * e?.Unidades;
    });
    return round2(total);
  };
  const getInSituConTransporteEuros = () => {
    let total = 0;
    activeEdit?.LineasVentaCompuestas?.forEach(e => {
      total += e?.InSituConTransporteEuros * e?.Unidades;
    });
    return round2(total);
  };

  const handleSubmit = (values, { setSubmitting }) => {
    const payload = {
      ...values,
      FechaEnvioPresupuesto: !values.FechaEnvioPresupuesto ? null : values.FechaEnvioPresupuesto,
      FechaEnvioVoucher: !values.FechaEnvioVoucher ? null : values.FechaEnvioVoucher,
      FechaFactura: !values.FechaFactura ? null : values.FechaFactura,
      FechaPagoReserva: !values.FechaPagoReserva ? null : values.FechaPagoReserva,
      PorcDescuento: !values.PorcDescuento ? 0 : +values.PorcDescuento,
    };
    //console.log( payload )
    dispatch(startUpdateInvoice(activeEdit?.PkVentas, payload, setSubmitting));
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={esLocale}>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchemaOrder}
          onSubmit={handleSubmit}>
          {({ handleChange, errors, values, handleBlur, isSubmitting, touched, isValid, setFieldValue }) => (
            <Form>
              <Grid container spacing={3}>
                <Grid md={3} xs={8} item>
                  <Field
                    style={{ fontSize: '0.7em' }}
                    component={FormikDatePicker}
                    textfield="FechaVenta"
                    name="FechaVenta"
                    label="Fecha Venta"
                    isSubmitting={isSubmitting}
                    value={values?.FechaVenta}
                  />
                </Grid>

                <Grid md={1} xs={4} item>
                  <TextField
                    fullWidth
                    label="Nº"
                    name="PkVentas"
                    size="small"
                    variant="outlined"
                    classes={{ root: classes.inputText }}
                    value={values.PkVentas}
                    InputProps={{
                      classes: {
                        input: classes.resize,
                      },
                    }}
                    InputLabelProps={{ style: { fontSize: '0.8em' } }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={touched.PkVentas && Boolean(errors.PkVentas)}
                    helperText={touched.PkVentas && errors.PkVentas}
                    disabled={true}
                    inputProps={{ maxLength: 5 }}
                  />
                </Grid>

                <Grid md={6} xs={12} item>
                  <TextField
                    fullWidth
                    label="Cliente"
                    name="Cliente.Nombre"
                    size="small"
                    variant="outlined"
                    classes={{ root: classes.inputText }}
                    value={`${activeEdit?.Cliente?.Nombre} ${activeEdit?.Cliente?.Apellidos}`}
                    InputProps={{
                      classes: {
                        input: classes.resize,
                      },
                    }}
                    InputLabelProps={{ style: { fontSize: '0.8em' } }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    disabled={true}
                    inputProps={{ maxLength: 5 }}
                  />
                </Grid>

                {(idRol === ROLADMIN || idRol === ROLVENDEDOR) && (
                  <Grid md={2} xs={12} item>
                    <Button
                      fullWidth
                      style={{
                        marginRight: '20px',
                        backgroundColor: '#F39868',
                        color: '#fff',
                        borderRadius: 7,
                        marginLeft: 10,
                      }}
                      onClick={() => navigate(`/clients/${activeEdit?.Cliente?.PkClientes}`)}>
                      <Typography style={{ fontWeight: 'bold' }}>Ver cliente </Typography>
                    </Button>
                  </Grid>
                )}
              </Grid>

              <Grid container spacing={3}>
                <LinesTable />
              </Grid>

              <Grid container spacing={3}>
                {idRol !== ROLREVENDEDOR && (
                  <>
                    <Grid item md={4} sm={6} xs={12}>
                      <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                        <Typography variant="h4" color="textPrimary">
                          {`Dto:`}
                        </Typography>
                        <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                          {formatImporte(getTotal(), 'EUR')}
                        </Typography>
                      </Box>
                    </Grid>
                  </>
                )}

                {(idRol !== ROLREVENDEDOR || (idRol === ROLREVENDEDOR && monedaUsuario === 'EUR')) && (
                  <Grid item md={4} sm={6} xs={12}>
                    <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                      <Typography variant="h4" color="textPrimary">
                        {`Tasas totales:`}
                      </Typography>
                      <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                        {formatImporte(getTotalTasas(), 'EUR')}
                      </Typography>
                    </Box>
                  </Grid>
                )}

                {(idRol !== ROLREVENDEDOR || (idRol === ROLREVENDEDOR && monedaUsuario === 'USD')) && (
                  <Grid item md={4} sm={6} xs={12}>
                    <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                      <Typography variant="h4" color="textPrimary">
                        {`Tasas totales:`}
                      </Typography>
                      <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                        {formatImporte(getTotalTasasDolares(), 'USD')}
                      </Typography>
                    </Box>
                  </Grid>
                )}

                {fromB2B && (idRol !== ROLREVENDEDOR || (idRol === ROLREVENDEDOR && monedaUsuario === 'EUR')) && (
                  <Grid item md={4} sm={6} xs={12}>
                    <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                      <Typography variant="h4" color="textPrimary">
                        {`Neto total:`}
                      </Typography>
                      <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                        {formatImporte(getTotalNeto(), 'EUR')}
                      </Typography>
                    </Box>
                  </Grid>
                )}

                {fromB2B && (idRol !== ROLREVENDEDOR || (idRol === ROLREVENDEDOR && monedaUsuario === 'USD')) && (
                  <Grid item md={4} sm={6} xs={12}>
                    <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                      <Typography variant="h4" color="textPrimary">
                        {`Neto total:`}
                      </Typography>
                      <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                        {formatImporte(getTotalNetoDolares(), 'USD')}
                      </Typography>
                    </Box>
                  </Grid>
                )}

                {!fromB2B && (idRol !== ROLREVENDEDOR || (idRol === ROLREVENDEDOR && monedaUsuario === 'EUR')) && (
                  <Grid item md={4} sm={6} xs={12}>
                    <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                      <Typography variant="h4" color="textPrimary">
                        {`PVP Total:`}
                      </Typography>
                      <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                        {formatImporte(getTotalInvoice(activeEdit), 'EUR')}
                      </Typography>
                    </Box>
                  </Grid>
                )}

                {!fromB2B && (idRol !== ROLREVENDEDOR || (idRol === ROLREVENDEDOR && monedaUsuario === 'USD')) && (
                  <Grid item md={4} sm={6} xs={12}>
                    <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                      <Typography variant="h4" color="textPrimary">
                        {`PVP Total:`}
                      </Typography>
                      <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                        {formatImporte(getTotalInvoiceDolares(activeEdit), 'USD')}
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>

              <Grid container spacing={3}>
                {!fromB2B && activeEdit?.Usuario?.FkRoles === ROLREVENDEDOR && (
                  <>
                    {activeEdit?.Usuario?.Moneda === 'USD' && (
                      <>
                        <Grid item md={4} sm={6} xs={12}>
                          <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                            <Typography variant="h4" color="textPrimary">
                              {`Insitu + Supl. transporte:`}
                            </Typography>
                            <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                              {formatImporte(getInSituConTransporte(), 'USD')}
                            </Typography>
                          </Box>
                        </Grid>
                      </>
                    )}
                    {activeEdit?.Usuario?.Moneda === 'EUR' && (
                      <>
                        <Grid item md={4} sm={6} xs={12}>
                          <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                            <Typography variant="h4" color="textPrimary">
                              {`Insitu + Supl. transporte:`}
                            </Typography>
                            <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                              {formatImporte(getInSituConTransporteEuros(), 'EUR')}
                            </Typography>
                          </Box>
                        </Grid>
                      </>
                    )}

                    <Grid item md={4} sm={6} xs={12}>
                      <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                        <Typography variant="h4" color="textPrimary">
                          {`Pago cliente a Agencia:`}
                        </Typography>
                        <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                          {formatImporte(getPagoClienteAgencia(), 'EUR')}
                        </Typography>
                      </Box>
                    </Grid>
                  </>
                )}

                {!fromB2B &&
                  activeEdit?.Usuario?.Moneda === 'EUR' &&
                  (idRol === ROLADMIN || (idRol === ROLREVENDEDOR && esAgencia)) &&
                  activeEdit?.Usuario?.FkRoles === ROLREVENDEDOR &&
                  !activeEdit?.Usuario?.MargenConfiguradoEnServicios && (
                    <Grid item md={4} sm={6} xs={12}>
                      <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                        <Typography variant="h4" color="textPrimary">
                          {`Pago Agencia a Xplora:`}
                        </Typography>
                        <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                          {formatImporte(getPagoAgenciaXploraEuros(), 'EUR')}
                        </Typography>
                      </Box>
                    </Grid>
                  )}
                {!fromB2B &&
                  activeEdit?.Usuario?.Moneda === 'USD' &&
                  (idRol === ROLADMIN || (idRol === ROLREVENDEDOR && esAgencia)) &&
                  activeEdit?.Usuario?.FkRoles === ROLREVENDEDOR &&
                  !activeEdit?.Usuario?.MargenConfiguradoEnServicios && (
                    <Grid item md={4} sm={6} xs={12}>
                      <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                        <Typography variant="h4" color="textPrimary">
                          {`Pago Agencia a Xplora:`}
                        </Typography>
                        <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                          {formatImporte(getPagoAgenciaXploraDolares(), 'USD')}
                        </Typography>
                      </Box>
                    </Grid>
                  )}

                {idRol === ROLADMIN &&
                  activeEdit?.Usuario?.FkRoles === ROLREVENDEDOR &&
                  activeEdit?.Usuario?.MargenConfiguradoEnServicios && (
                    <Grid item md={4} sm={6} xs={12}>
                      <Box style={{ marginTop: '2rem', flexDirection: 'column' }}>
                        <Typography variant="h4" color="textPrimary">
                          {`Pago Proveedor a Xplora:`}
                        </Typography>
                        <Typography variant="body1" style={{ paddingLeft: '0.5rem', fontSize: '1rem' }}>
                          {formatImporte(getPagoProveedorXplora(), 'EUR')}
                        </Typography>
                      </Box>
                    </Grid>
                  )}
              </Grid>

              <>
                <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  {showActionButtons && (
                    <Grid
                      item
                      md={12}
                      xs={12}
                      style={{
                        marginTop: '1rem',
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}>
                      <Button
                        style={{
                          marginRight: '20px',
                          backgroundColor: '#F39868',
                          color: '#fff',
                          borderRadius: 7,
                          marginLeft: 10,
                        }}
                        onClick={() => navigate('/sales')}>
                        <Typography style={{ fontWeight: 'bold' }}>Cancelar </Typography>
                      </Button>
                      {!activeEdit?.FechaFactura && (
                        <LoadingButton
                          variant="contained"
                          type="submit"
                          style={{
                            backgroundColor: '#E5824F',
                          }}
                          disabled={isSubmitting || !isValid}>
                          Guardar Cambios
                        </LoadingButton>
                      )}
                    </Grid>
                  )}
                </Box>
              </>
            </Form>
          )}
        </Formik>
      </LocalizationProvider>
    </>
  );
};
